/**
 * @module components/MergeSameCells
 * @description 表格合并相同单元格（页面展示 + Excel 下载）
 *
 * 状态管理模式：FreezePanes 模板
 *   读: base/draft.merge_same_cells → { enabled }
 *   写: dispatch(UPDATE_DRAFT, { merge_same_cells: { enabled } })
 */

import React, { useCallback } from 'react';
import { useIntl } from 'umi';
import { Switch } from 'tea-component';
import ConfigCard from '@/pages/datalab/components/ConfigCard';
import { CSActionType } from '../../types';
import { useChartSettingsSelector, useChartSettingsDispatch } from '../../context';

interface IMergeSameCellsProps {
  visibleItems?: Record<string, boolean>;
}

interface IMergeSameCellsValue {
  enabled: boolean;
}

const DEFAULT_MERGE_SAME_CELLS: IMergeSameCellsValue = { enabled: false };

const MergeSameCells: React.FC<IMergeSameCellsProps> = () => {
  const { formatMessage } = useIntl();
  const dispatch = useChartSettingsDispatch();

  const mergeVal = useChartSettingsSelector(
    (s) =>
      (s.draft.merge_same_cells ??
        s.base.merge_same_cells ??
        DEFAULT_MERGE_SAME_CELLS) as IMergeSameCellsValue,
  );
  const enabled = mergeVal?.enabled ?? false;

  const handleSwitchChange = useCallback(
    (nextEnabled: boolean): void => {
      dispatch({
        type: CSActionType.UPDATE_DRAFT,
        payload: {
          merge_same_cells: { enabled: nextEnabled },
        },
      });
    },
    [dispatch],
  );

  return (
    <ConfigCard
      title={
        <span>{formatMessage({ id: 'dbl_chart_merge_same_cells' })}</span>
      }
      operation={<Switch value={enabled} onChange={handleSwitchChange} />}
    />
  );
};

export default React.memo(MergeSameCells);
